<template>
    <section class="row flexbox-container">
  <div class="col-xl-8 col-11 d-flex justify-content-center">
      <div class="card bg-authentication rounded-0 mb-0">
          <div class="row m-0">
              <div class="col-lg-6 d-lg-block d-none text-center align-self-center">
                  <img src="/images/pages/login.jpeg" width="332px"  alt="branding logo">
              </div>
              <div class="col-lg-6 col-12 p-0">
                  <div class="card rounded-0 mb-0 px-2 py-1">
                      <div class="card-header pb-1">
                          <div class="card-title">
                              <h4 class="mb-0">{{trans('auth.two_factor_security')}}</h4>
                          </div>
                      </div>
                      
                      <div class="card-content">
                          <div class="card-body">
                                <center class="m-t-30"> <img :src="getAuthUser('avatar')" class="rounded-circle img-border box-shadow-1" width="100" />
                                    <h4 class="card-title m-t-10">{{getAuthUser('full_name')}}</h4>
                                </center><br>
                              <form id="twoFactorForm" @submit.prevent="submit" @keydown="twoFactorForm.errors.clear($event.target.name)">
                                <fieldset class="form-label-group form-group position-relative has-icon-left">

                                  <input type="text" name="two_factor_code" class="form-control text-center" :class="{ 'is-invalid': twoFactorForm.errors.has('two_factor_code') }" :placeholder="trans('auth.two_factor_code')" v-model="twoFactorForm.two_factor_code" autocomplete="two_factor_code" autofocus>
                        
                                <div class="form-control-position">
                                      <i class="feather icon-lock"></i>
                                  </div>
                                      <label for="two_factor_code">{{ trans('auth.two_factor_code') }}</label>

                                      <show-error :form-name="twoFactorForm" prop-name="two_factor_code"></show-error>
 
                              </fieldset>
                                 

                                  <div class="float-md-left d-block mb-1">
                                    <a href="#" @click.prevent="logout" class="btn btn-outline-primary btn-block px-75"><i class="fas fa-power-off"></i> {{trans('auth.logout')}}</a>
                                  </div>
                                  <div class="float-md-right d-block mb-1">
                                    <button type="submit" class="btn btn-primary btn-block px-75">{{trans('auth.confirm')}}</button>
                                  </div>
                              </form>

                            </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>

</template>
<script>
    import guestFooter from '../../layouts/guest-footer.vue'

    export default {
        components: {guestFooter},
        data(){
            return {
                twoFactorForm: new Form({
                    two_factor_code: '',
                })
            }
        },
        mounted(){
            if(!helper.getConfig('two_factor_security') || !helper.getTwoFactorCode())
                this.$router.push('/home');

            if(!helper.getConfig('mode'))
                this.twoFactorForm.two_factor_code = helper.getTwoFactorCode();
        },
        methods: {
            logout(){
                helper.logout().then(() => {
                    this.$store.dispatch('resetAuthUserDetail');
                    this.$router.push('/login')
                })
            },
            submit(){
                if(this.twoFactorForm.two_factor_code == helper.getTwoFactorCode()){
                    this.$store.dispatch('resetTwoFactorCode');
                    toastr.success(i18n.auth.two_factor_security_verified);
                    this.$router.push('/home');
                } else {
                    toastr.error(i18n.auth.invalid_two_factor_code);
                }
            },
            getAuthUser(name){
                return helper.getAuthUser(name);
            }
        },
        computed: {
        }
    }
</script>
